import { createContext, Dispatch, SetStateAction } from 'react';

import { FormInstance } from 'antd';

import { Feature, SelectOption } from '../../../../../../../../../shared/interfaces';

interface StepThreeFormContextProps {
  stepThreeForm:                      FormInstance<any> | undefined;

  hasStepThreeFormChanged:            boolean,
  setStepThreeHasFormChanged:         Dispatch<SetStateAction<boolean>>;

  fireFormValues:                     any;
  setFireFormValues:                  Dispatch<SetStateAction<any>>;

  activeKey:                          any;
  setActiveKey:                       Dispatch<SetStateAction<any>>;

  tabs:                               Array<any>;
  setTabs:                            Dispatch<SetStateAction<Array<any>>>;

  newTabIndex:                        { current: number };

  plansByActivityList:                Array<SelectOption>;

  allFeatures:                        Array<{ plan: string; keyTab: number; features: Array<Feature> }>;
  setAllFeatures:                     Dispatch<SetStateAction<Array<{ plan: string; keyTab: number; features: Array<Feature> }>>>;

  showModal:                          boolean;
  setShowModal:                       Dispatch<SetStateAction<boolean>>;

  keyTabToDelete:                     number | null;
  setKeyTabToDelete:                  Dispatch<SetStateAction<number | null>>;

  addNewTab:                          (id?: number) => void;
  duplicateTab:                       (id?: number) => void;
  removeTab:                          (id?: any) => void;

  getFeaturesRisks:                   ( planSelected: string, componente: number ) => Promise<Array<Feature>>;
  getFeaturesRiskByPlan:                   (id: number, planSelected: string, componente: number ) => void;

  getListPlansActivity:               () => Promise<void>;
}

export const StepThreeFormContext = createContext(
  {} as StepThreeFormContextProps
);
